import React from 'react';

import { DASH } from 'Components/budget_change_requests/changeRequestFormat';

import { amount, calendarDate, ChangeArrow } from './commitmentFormat';

const CONTRACT_STATUS = {
    signed: { label: () => $t('Signed'), chip: 'bc-chip bc-chip--green' },
    closed: { label: () => $t('Closed'), chip: 'bc-chip bc-chip--grey' },
    not_signed: { label: () => $t('Not signed'), chip: 'bc-chip bc-chip--grey' },
};

const REQUISITION_CHIP = {
    approved: 'bc-chip bc-chip--green',
    confirmed: 'bc-chip bc-chip--green',
    converted: 'bc-chip bc-chip--green',
    rejected: 'bc-chip bc-chip--grey',
    cancelled: 'bc-chip bc-chip--grey',
};

/**
 * The supplier and contract beside the plan item and requisition the commitment was
 * raised from, with the requisition's estimate set against what is now committed.
 */
export default function CommitmentContractSection({ detail }) {
    const contractStatus = CONTRACT_STATUS[detail.contract_status] ?? CONTRACT_STATUS.not_signed;
    const requisition = detail.purchase_requisition;

    return (
        <div className="bc-kv tw-mb-0">
            <div className="tw-flex tw-flex-col">
                <div className="bc-kv__cell">
                    <span className="bc-kv__key">{$t('Supplier')}</span>
                    {detail.supplier || DASH}
                </div>
                <div className="bc-kv__cell">
                    <span className="bc-kv__key">{$t('Contract period')}</span>
                    {$t('{{start}} to {{end}}', { start: calendarDate(detail.contract_started_at), end: calendarDate(detail.contract_ended_at) })}
                </div>
                <div className="bc-kv__cell">
                    <span className="bc-kv__key">{$t('Contract status')}</span>
                    <span className={contractStatus.chip}>{contractStatus.label()}</span>
                </div>
            </div>
            <div className="tw-flex tw-flex-col">
                <div className="bc-kv__cell">
                    <span className="bc-kv__key">{$t('Procurement plan item')}</span>
                    {detail.procurement_plan_item || DASH}
                </div>
                {requisition ? (
                    <>
                        <div className="bc-kv__cell">
                            <span className="bc-kv__key">{$t('Purchase requisition')}</span>
                            <span className="tw-inline-flex tw-flex-wrap tw-items-center tw-gap-2">
                                {requisition.reference}
                                <span className={REQUISITION_CHIP[requisition.status] ?? 'bc-chip bc-chip--amber'}>{requisition.status_label}</span>
                            </span>
                        </div>
                        <div className="bc-kv__cell">
                            <span className="bc-kv__key">{$t('PR estimated value vs commitment')}</span>
                            <span className="tw-inline-flex tw-flex-wrap tw-items-center tw-gap-2 tw-tabular-nums">
                                {amount(requisition.estimated_value)} <ChangeArrow /> {amount(requisition.commitment_value)}
                                <Variance value={requisition.variance} />
                            </span>
                        </div>
                    </>
                ) : (
                    <div className="bc-kv__cell">
                        <span className="bc-kv__key">{$t('Purchase requisition')}</span>
                        {$t('No purchase requisition')}
                    </div>
                )}
            </div>
        </div>
    );
}

/** Commitment minus estimate: over the estimate is the figure an approver needs to see. */
function Variance({ value }) {
    if (Math.abs(Number(value) || 0) < 0.005) {
        return <span className="bc-chip bc-chip--green">{$t('No variance')}</span>;
    }

    return (
        <span className={value > 0 ? 'bc-chip bc-chip--amber' : 'bc-chip bc-chip--grey'}>
            {value > 0 ? $t('{{value}} over estimate', { value: amount(value) }) : $t('{{value}} under estimate', { value: amount(Math.abs(value)) })}
        </span>
    );
}
